import React from 'react';
import { CheckCircle2, LucideProps } from 'lucide-react';

/**
 * Standardized Success icon component.
 * Wraps the lucide-react CheckCircle2 icon for consistent usage across the app.
 */
export const SuccessIcon: React.FC<LucideProps> = (props) => {
  return <CheckCircle2 {...props} />;
};
